/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do the months and days in my result look uneven?`)
};

const es_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los meses y días en mi resultado se ven desiguales?`)
};

const de_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sehen die Monate und Tage in meinem Ergebnis ungleichmäßig aus?`)
};

const nl_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zien de maanden en dagen in mijn resultaat onevenredig uit?`)
};

const fr_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les mois et les jours de mon résultat semblent-ils inégaux ?`)
};

const it_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i mesi e i giorni nel mio risultato sembrano irregolari?`)
};

const pt_br2_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os meses e dias do meu resultado parecem desiguais?`)
};

const pt_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que é que os meses e dias no meu resultado parecem desiguais?`)
};

const ja_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果の月と日がなぜ不均等に見えるのですか？`)
};

const zh_age_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么结果中的月数和天数看起来不太规则？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq4_q", locale)
	if (locale === "en") return en_age_faq4_q(inputs)
	if (locale === "es") return es_age_faq4_q(inputs)
	if (locale === "de") return de_age_faq4_q(inputs)
	if (locale === "nl") return nl_age_faq4_q(inputs)
	if (locale === "fr") return fr_age_faq4_q(inputs)
	if (locale === "it") return it_age_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq4_q(inputs)
	if (locale === "pt") return pt_age_faq4_q(inputs)
	if (locale === "ja") return ja_age_faq4_q(inputs)
	return zh_age_faq4_q(inputs)
};